"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const LinearProgress_1 = tslib_1.__importDefault(require("@mui/material/LinearProgress"));
/**
 * A wrapper around {@link @mui/material.LinearProgress} that also takes up space if its not loading.
 * Normal usage if {@link @mui/material.LinearProgress} component will only render a component when loading actually happens
 * this causes the to progress bar to suddently take up space and move all other content down on the page.
 *
 * To avoid this, this wrapper will render the {@link @mui/material.LinearProgress} component no matter what, but visibility will be set to hidden if
 * `props.loading = false`.
 *
 * @category component
 */
const LinearProgress = (props) => {
    const { loading = false, color = "secondary", variant = "indeterminate", sx = [], ...restProps } = props;
    const muiLinearProgressProps = {
        ...restProps,
        color,
        variant,
        sx: {
            visibility: loading ? "inherit" : "hidden",
            ...(Array.isArray(sx) ? sx : [sx]),
        },
    };
    return react_1.default.createElement(LinearProgress_1.default, { ...muiLinearProgressProps });
};
exports.default = LinearProgress;
